import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { AuthShell, inputCls, primaryBtnCls } from "@/components/AuthShell";
import { useAuth } from "@/lib/auth";
import { errMsg } from "@/lib/api";
import { usePageTitle } from "@/lib/hooks";

export default function AdminLoginPage() {
  usePageTitle("Admin Login");
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell onSubmit={submit} testId="admin-login-form" title="Admin sign in" subtitle="Restricted to PRICEHUB administrators.">
      <label className="mt-8 block text-sm font-medium text-ph-ink/85" htmlFor="admin-email">Email</label>
      <input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" data-testid="admin-login-email" className={inputCls} />
      <div className="mt-5 flex items-center justify-between">
        <label className="block text-sm font-medium text-ph-ink/85" htmlFor="admin-password">Password</label>
        <Link to="/admin/forgot-password" data-testid="admin-login-forgot-link" className="text-xs font-semibold text-ph-accent hover:underline">Forgot password?</Link>
      </div>
      <input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" data-testid="admin-login-password" className={inputCls} />
      {error && <p className="mt-4 rounded-xl bg-red-500/10 px-4 py-3 text-sm text-red-600 dark:text-red-400" role="alert" data-testid="admin-login-error">{error}</p>}
      <button type="submit" disabled={busy} data-testid="admin-login-submit" className={primaryBtnCls}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Sign in
      </button>
    </AuthShell>
  );
}
